import React, { useEffect, useState } from 'react';
import { ProductApi, ProductDetailDTO } from '../../apis/ProductApi';
import { BaseCardContent } from '../MessageType';
import { CachedImage } from '../../components/CachedImage';
import { AppDetailClickable } from './AppDetailTip';

interface ProductCardViewProps {
  content: BaseCardContent;
  isSelf: boolean;
}

export const ProductCardView: React.FC<ProductCardViewProps> = ({ content }) => {
  const productId = content.productId as string;
  const specificationType = (content.specificationType as string) || 'standard';
  const [product, setProduct] = useState<ProductDetailDTO | null>(null);

  useEffect(() => {
    if (!productId) {
      return;
    }
    ProductApi.getProductDetail(productId).then(setProduct);
  }, [productId]);

  const title = product?.name || (content.title as string) || '技能商品';
  const imageUrl =
    product?.headImageUrl || (content.imageUrl as string) || '';
  const isTrial = specificationType === 'trial';
  const price = product
    ? isTrial
      ? product.trialPrice
      : product.standardPrice
    : (content.price as number);
  const specLabel = isTrial ? '体验版' : '标准版';
  const desc =
    (isTrial ? product?.trialDescription : product?.standardDescription) ||
    (content.description as string) ||
    '';

  return (
    <AppDetailClickable>
      <div className="message-card message-product-card">
        <div className="message-card-title">{title}</div>
        <div className="message-product-body">
          {imageUrl ? (
            <CachedImage
              url={imageUrl}
              enablePreview={false}
              style={{ width: 72, height: 72, borderRadius: 4 }}
            />
          ) : (
            <div className="message-product-thumb-placeholder" />
          )}
          <div className="message-product-info">
            <div className="message-product-spec">{specLabel}</div>
            <div className="message-product-desc">{desc}</div>
            {price != null && (
              <div className="message-product-price">¥{price}</div>
            )}
          </div>
        </div>
        <div className="message-order-hint">点击前往 APP 查看详情</div>
      </div>
    </AppDetailClickable>
  );
};
